module.exports = __webpack_public_path__ + "static/media/yellow_doc_header@2x.ff96ebd2.png";